module.exports = __webpack_public_path__ + "static/img/design-bg.c35d2270.png";